import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _CostStudy, _Exportations, _ImportCostSettlement, _ImportDeclaration, _NationalizationProcessGeneralInfo, _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { MakeUBLInvoice } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectAdquisitionContract } from "../../../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { FileInput } from "../../../../../theme/Component/FileInput";
import { NationalizationProcessItemsByActStore } from "../NationalizationProcessItems/NationalizationProcessItemsByActStore";
import { CurrencyEditor } from "../../../../../erp/cellEditor/Currency/CurrencyEditor";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const ACTEM001 = ({ configProcedure }: Props) => {

    const actem = useDataBean(_NationalizationProcessGeneralInfo);
    const [invoice, setInvoice] = useState<any>({});
    const [props, setProps] = useState<any>({});
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalConfAdd, setModalConfAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])
    useEffect(() => {
        console.log("cargando de props => ", props.IDNationalizationProcessGeneralInfo);

        if (props.IDNationalizationProcessGeneralInfo) {
            actem.instance.getNationalizationProcessGeneralInfoCatalogPorPropiedades({ IDNationalizationProcessGeneralInfo: props.IDNationalizationProcessGeneralInfo }, null).then(
                (resp: any) => {
                    if (resp.length > 0) {
                        console.log(resp[0].DataBeanProperties);
                        actem.setBean(resp[0].DataBeanProperties);
                    }

                }
            )
        }
    }, [props])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(actem.bean.ObservationsEC)
        }

        if (configProcedure?._pushProps) {
            let x = {
                IDNationalizationProcessGeneralInfo: actem.bean.IDNationalizationProcessGeneralInfo,
                State: 1
            }
            configProcedure?._pushProps(x)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(actem.bean)
        }
        toast.success('Actualizado')
    }


    const create = () => {
        actem.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        editaItem()
    }

    const createvdos = () => {
        actem.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        editaItemvdos()
    }

    const editaItem = () => {
        //console.log(entailment.bean);
        actem.instance.updateNationalizationProcessGeneralInfo(actem.bean).then(
            (resp: any) => {
                onExportMap()
                console.log(resp)
                toast.success('Actualizado');
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    const editaItemvdos = () => {

        actem.instance.updateNationalizationProcessGeneralInfo(actem.bean).then(
            (resp: any) => {
                console.log(resp);
                toast.success('Actualizado');
                actem.setBean(resp);
                configProcedure._pushProps({ IDNationalizationProcessGeneralInfo: resp.IDNationalizationProcessGeneralInfo, State: 1 });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (

        <div className="row">
            <div className="col-md-12">


                <div className="row">
                    <div className="col-md-12">

                        <SelectAdquisitionContract data={{ IDAccount: actem.bean.IDAccount }} idSelector={actem.bean.IDAdquisitionContract} onChange={({ DataBeanProperties }) => { actem.setBean({ ...actem.bean, 'IDAdquisitionContract': DataBeanProperties.IDAdquisitionContract }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>No. Documento Transporte</label>
                        <input type="text" name="NoDocTransport" className="form-control" value={actem.bean.NoDocTransport} onChange={actem.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>No. Acta de entrega de mercancia</label>
                        <input type="text" name="NoDeliveryActEM" className="form-control" value={actem.bean.NoDeliveryActEM} onChange={actem.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="DateEM" label="Fecha de registro de Entrega de Mercancia" value={actem.bean.DateEM} setDate={(e: any) => { actem.setBean({ ...actem.bean, "DateEM": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Deposito de entrega de Mercancia</label>
                        <input type="text" name="DepositEM" className="form-control" value={actem.bean.DepositEM} onChange={actem.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Ciudad / Dirección de entrega de Mercancia</label>
                        <input type="text" name="AdressEM" className="form-control" value={actem.bean.AdressEM} onChange={actem.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <CurrencyEditor id={actem.bean.CurrencyType} onchange={(e: any) => { actem.setBean({ ...actem.bean, "CurrencyType": e }) }}></CurrencyEditor>
                    </div>
                    <div className="col-md-6">
                        <InputDate name="DeliveryDateEM" label="Fecha de Entrega de la Mercancia" value={actem.bean.DeliveryDateEM} setDate={(e: any) => { actem.setBean({ ...actem.bean, "DateEM": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Peso Bruto de entrega de mercancia</label>
                        <input type="text" name="GrossWeightEM" className="form-control" value={actem.bean.GrossWeightEM} onChange={actem.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <FileInput
                            Media={actem.bean.Media}
                            MediaContext={actem.bean.MediaContext}
                            directory='registrophoto'
                            label='Registro fotográfico de la entrega de la mercancia x1'
                            // onCreate={(e) => { Comparison.setBean({ ...Comparison.bean, 'AttachFiles': e});console.log(e) }}
                            onCreate={({ MediaContext, Media }: any) => { actem.setBean({ ...actem.bean, "PhographEvidenceEM": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                        ></FileInput>
                    </div>
                    <div className="col-md-6">
                        <FileInput
                            Media={actem.bean.Media}
                            MediaContext={actem.bean.MediaContext}
                            directory='registrophoto'
                            label='Registro fotográfico de la entrega de la mercancia x2'
                            // onCreate={(e) => { Comparison.setBean({ ...Comparison.bean, 'AttachFiles': e});console.log(e) }}
                            onCreate={({ MediaContext, Media }: any) => { actem.setBean({ ...actem.bean, "PhographEvidenceEM2": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                        ></FileInput>
                    </div>
                    <div className="col-md-6">
                        <FileInput
                            Media={actem.bean.Media}
                            MediaContext={actem.bean.MediaContext}
                            directory='registrophoto'
                            label='Registro fotográfico de la entrega de la mercancia x3'
                            // onCreate={(e) => { Comparison.setBean({ ...Comparison.bean, 'AttachFiles': e});console.log(e) }}
                            onCreate={({ MediaContext, Media }: any) => { actem.setBean({ ...actem.bean, "PhographEvidenceEM3": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                        ></FileInput>
                    </div>
                    <div className="col-md-6">
                        <FileInput
                            Media={actem.bean.Media}
                            MediaContext={actem.bean.MediaContext}
                            directory='registrophoto'
                            label='Registro fotográfico de la entrega de la mercancia x4'
                            // onCreate={(e) => { Comparison.setBean({ ...Comparison.bean, 'AttachFiles': e});console.log(e) }}
                            onCreate={({ MediaContext, Media }: any) => { actem.setBean({ ...actem.bean, "PhographEvidenceEM4": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                        ></FileInput>
                    </div>
                    <div className="col-md-12">
                        <label>Observaciones</label>

                        <textarea name="ObservationsEM" className="form-control" value={actem.bean.ObservationsEM} onChange={(e) => { actem.setBean({ ...actem.bean, 'ObservationsEM': e.target.value }) }} />
                    </div>

                </div>
                <div className="row">
                    <div className="col-md-6">
                        <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={createvdos}>Guardar Datos*</BasicButton>
                    </div>
                </div>
                {actem.bean.IDNationalizationProcessGeneralInfo &&
                    <>
                        <div className="row">
                            {/* <PrintJson json={costestudy.bean} /> */}
                            <NationalizationProcessItemsByActStore IDNationalizationProcessGeneralInfo={actem.bean.IDNationalizationProcessGeneralInfo} />
                        </div>
                        <div className="row">
                            <div className="col-md-6">

                                <BasicButton icon="ri-inbox-unarchive-fill" clase="btn rounded-pill btn-warning waves-effect waves-light" eventClick={create}>Finalizar*</BasicButton>
                            </div>
                        </div>
                    </>
                }
            </div>
        </div>
    )
}